"use strict";
function popFromObject(object, key) {
    if (object) {
        var value = object[key];
        delete object[key];
        return value;
    }
}
exports.popFromObject = popFromObject;



/*****************
 ** WEBPACK FOOTER
 ** ./~/coveo.analytics/dist/utils.js
 ** module id = 91
 ** module chunks = 0 1
 **/